module.exports = __webpack_public_path__ + "media/images/logo_pl-7fcca3c54e303612b1c65fa4aa773a62.svg";